<template name="comp-tab">
  <div class="assemble-card-box">
    <div class="title-row">
      <div>
        {{ item.viewName }}
      </div>
      <!-- <div class="tag">
        {{ Lang.label.published }}
      </div> -->
    </div>
    <div class="address">页面ID：{{ item.id }}</div>
    <div class="btn-row">
      <div class="btn" @click.stop="handleEditPage">{{ Lang.btn.edit }}</div>
      <div class="btn" @click.stop="handleDeletePage">{{ Lang.btn.delete }}</div>
      <div class="btn" @click.stop="handleViewDetail">{{ Lang.label.viewPath }}</div>
      <div class="btn" @click.stop="handleEditDetail">{{ Lang.label.editPage }}</div>
    </div>
  </div>
</template>

<script>
  import { getDataPage, savePage, updatePage, removePage } from '@/api/assemble/index';

  export default {
    name: 'pageCard',
    props: {
      item: {
        type: Object,
        default() {
          return {}
        }
      }
    },

    data() {

    },
    computed: {

    },

    methods: {
      handleViewDetail() {
        this.$emit('viewPage', this.item);
      },
      handleEditDetail() {
        this.$emit('editPage', this.item);
      },
      handleEditPage() {
        this.$emit('edit', this.item);
      },
      handleDeletePage() {
        const id = this.item.id;
        this.$confirm(this.Lang.tips.ifConfirmDelete, {
          confirmButtonText: this.Lang.btn.confirm,
          cancelButtonText: this.Lang.btn.cancel,
          type: 'warning',
        })
          .then(() => {
            return removePage(id);
          })
          .then(() => {
            this.$message({
              type: 'success',
              message: this.Lang.tips.operationSuccess,
            });
            this.$emit('refresh');
          });
      },
    },
  }
</script>

<style lang="scss" scoped>

</style>
